<template><div><h1>VUX V2.5.9 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix error when format is YYYY #1861</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] donot set value to empty string when clicking on current selected item #1862</li>
</ul>
<h2><a href="/en/components/popup-header.html">PopupHeader</a></h2>
<ul><li>[fix] fix wrong slot name</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix layout errors when body not set 100% width #1867</li>
</ul>
<h2><a href="/en/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] Fix scrollTop always return 0 #1827</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] prop:show supports the .sync modifier</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.9 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.9-122.vue?47ccbbfa